import { baseAPICreator } from './apiCreator';

const garmApi = baseAPICreator('/host');

export const getHostsData = async (body: any): Promise<any> => {
  const { data } = await garmApi.post('', body);
  return data;
};
